import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { callForgerockLogout, autoLogin, autoLogout } from './HybrisSessionService';
import { configureForgerockSdk, getTokens } from "./ForgerockService.ts";

window.getTokens = async () => {
    return getTokens();
}

window.forgerockLogout = async (contextPath) => {
    await callForgerockLogout();
};

window.forgerockAutoLogin = async (contextPath, loginReferer) => {
    await autoLogin(contextPath, loginReferer);
};

window.forgerockAutoLogout = async (contextPath) => {
    await autoLogout(contextPath);
};

window.configureForgerock = (setup) => {
    configureForgerockSdk(setup);
}

window.createForgerockLoginWidget = (rootElement, contextPath, loginReferer, content, setup) => {
    const root = ReactDOM.createRoot(document.getElementById(rootElement));
    root.render(
        <React.StrictMode>
            <App contextPath={contextPath} loginReferer={loginReferer} content={content} setup={setup}/>
        </React.StrictMode>
    );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
